import { useEffect } from "react";

const SecurityProvider = ({ children }: { children: React.ReactNode }) => {
  const disableRightClick = import.meta.env.VITE_DISABLE_RIGHT_CLICK === "true";
  const forceEnableRightClick = sessionStorage.getItem("FERC") === "true";

  useEffect(() => {
    if (import.meta.env.DEV || forceEnableRightClick || !disableRightClick)
      return;

    const handleContextMenu = (e: MouseEvent) => {
      const target = e.target as HTMLElement;

      if (target.closest(".allow-right-click")) return;

      e.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  return <>{children}</>;
};

export default SecurityProvider;
